import "moment-timezone";
import queryString from 'query-string';
import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import Moment from 'react-moment';
import { Link } from 'react-router-dom';
import RegistrationActions from '../Actions/registrationActions';
import AuthContext from '../auth-context';
import Flags from '../SeminarRegistrations/Flags';
import ConfirmButton from '../Shared/ConfirmButton';

class RegistrationsTable extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.state = { items: props.items };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return nextProps.items === prevState.items
      ? {}
      : { items: nextProps.items };
  }

  handleSelectChange = (event, id) => {
    const checked = event.target.checked;
    this.changeSelectedState(id, checked)
  }

  changeSelectedState = (id, checked) => {
    this.props.itemSelectStateChanged(id, checked)
  }

  handleSelectAllChange = (event) => {
    if (this.state.checkedSelectAll) {
      this.props.itemSelectAllChanged(false)
      this.setState({ checkedSelectAll: false })
    } else {
      this.props.itemSelectAllChanged(true)
      this.setState({ checkedSelectAll: true })
    }
  }

  bookTCS = (deal) => {

    this.setState({ showModalNeedRefresh: true })
    const authStore = this.context
    const profile = authStore.profile
    const data = {
      email: deal.email,
      first_name: deal.first_name,
      mobile: deal.mobile,
      student_first_name: deal.student_first_name,
      deal_id: deal.id,
      m1_booking_user: profile.email,
      booking_from: 'seminar',
      business_stream: 'seminar',
      redirect_url: window.location,
      region: deal.region
    }
    const params = queryString.stringify(data)
    const url = `${process.env.REACT_APP_BOOKING_URL}?${params}`
    window.open(url, "_blank")
  }

  render() {
    const Table = props => {
      return (
        <tbody>
          {props.items.map(item => (
            <TableItem
              key={item.id}
              item={item}
              handleViewClick={this.handleViewClick}
            />
          ))}
        </tbody>
      );
    };

    const Header = props => {
      return (
        <thead className='dark'>
          <tr>
            <th style={{ width: 10 }}>{this.props.itemSelectStateChanged ? <input type="checkbox" checked={this.state.checkedSelectAll} onChange={this.handleSelectAllChange} /> : <span>ID</span>}</th>
            <th>#</th>
            <th colSpan="2">Parent</th>
            <th>Student</th>
            <th>Mobile</th>
            <th>TCS</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
      );
    };
    const TableItem = props => {
      const deal = props.item
      const actions = new RegistrationActions(deal, this.props.handleDealsUpdated)

      return (
        <tr>
          <td data-label="Select">
            {this.props.itemSelectStateChanged && <input style={{ marginRight: 10 }} type="checkbox" checked={deal.isSelected} onChange={(event) => this.handleSelectChange(event, deal.id)} />}
          </td>
          <td data-label="Registration ID">
            {deal.registration_number}
          </td>
          <td data-label="Parent">
            <Link to={`/m1/deals/${deal.id}`}>{deal.first_name}</Link>
          </td>
          <td data-label="Email">{deal.email}</td>
          <td data-label="Student">{deal.student_first_name}</td>
          <td data-label="Mobile" style={{ whiteSpace: "nowrap" }}>
            {deal.mobile}
          </td>
          <td>
            {deal.tcs_at ? <Moment format="h:mma MMM Do YYYY">{deal.tcs_at}</Moment> : '-'}
          </td>
          <td data-label="Status">
            <Flags deal={deal} />
          </td>
          <td>
            {this.props.view === 'confirmation' && <ConfirmButton text='Confirm Attendee' okAction={(note) => actions.registrationMarkAttendeeConfirmed(note)} />}
            {this.props.view === 'attendance' && <ConfirmButton text='Seminar Attended' okAction={(note) => actions.registrationMarkSeminarAttended(note)} />}
            {this.props.view === 'attended_no_tcs' && <Button bsStyle="info" bsSize="xsmall" onClick={() => this.bookTCS(deal)}>Book TCS</Button>}
          </td>
        </tr>
      );
    };
    return (
      <div>
        <table
          className="table table-hover table-bordered stable-condensed responsive"
          style={{ width: "100%" }}
        >
          <Header />
          <Table items={this.state.items} />
        </table>

        <Modal show={this.state.showModalNeedRefresh} onHide={() => window.location.reload(true)} bsSize="large">
          <Modal.Header>
            <Modal.Title>Booking a TCS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>After you have booked a TCS, the page will need to be reloaded</p>
            <div>
              <Button bsStyle='success' bsSize='small' onClick={() => window.location.reload(true)}>Reload Now</Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default RegistrationsTable